export default __webpack_public_path__ + "static/coupleWorking-549ddfb020ca26e8df322f60b7aca8c8.png";